<template>
  <v-form>
    <v-row :class="{ 'mt-4': $vuetify.breakpoint.smAndDown }" no-gutters>
      <v-col cols="12" md="9">
        <v-row>
          <template v-if="!forReservation && !forGraduation && !forAbortion">
            <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
              <v-select
                flat
                filled
                dense
                clearable
                item-text="text"
                item-value="value"
                :items="studentTypeOptions"
                placeholder="Loại học viên"
                v-model="type"
              ></v-select>
            </v-col>
            <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
              <v-autocomplete
                v-model="status"
                :items="studentStatuses"
                clear-icon="mdi-close"
                item-text="title"
                item-value="status"
                placeholder="Trạng thái"
                flat
                filled
                dense
                clearable
                deletable-chips
              ></v-autocomplete>
            </v-col>
          </template>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <v-text-field
              v-model="name"
              clear-icon="mdi-close"
              placeholder="Họ và tên"
              flat
              filled
              dense
              clearable
            />
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <v-text-field
              v-model="code"
              clear-icon="mdi-close"
              placeholder="Mã học viên"
              flat
              filled
              dense
              clearable
            />
          </v-col>
        </v-row>
        <v-row v-show="getShow" v-if="forReservation">
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <date-selector
              label="Bắt đầu bảo lưu sau"
              :date="transformDateForDatePicker(startDateAfter)"
              @change="onStartDateAfterChange"
              hideIcon
            ></date-selector>
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <date-selector
              label="Bắt đầu bảo lưu trước"
              :date="transformDateForDatePicker(startDateBefore)"
              @change="onStartDateBeforeChange"
              hideIcon
            ></date-selector>
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <date-selector
              label="Kết thúc bảo lưu sau"
              :date="transformDateForDatePicker(endDateAfter)"
              @change="onEndDateAfterChange"
              hideIcon
            ></date-selector>
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <date-selector
              label="Kết thúc bảo lưu trước"
              :date="transformDateForDatePicker(endDateBefore)"
              @change="onEndDateBeforeChange"
              hideIcon
            ></date-selector>
          </v-col>
        </v-row>
        <v-row v-show="getShow" v-else-if="forGraduation">
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <date-selector
              label="Nhập học sau"
              :date="transformDateForDatePicker(startDateAfter)"
              @change="onStartDateAfterChange"
              hideIcon
            ></date-selector>
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <date-selector
              label="Nhập học trước"
              :date="transformDateForDatePicker(startDateBefore)"
              @change="onStartDateBeforeChange"
              hideIcon
            ></date-selector>
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <date-selector
              label="Hoàn thành chương trình sau"
              :date="transformDateForDatePicker(endDateAfter)"
              @change="onEndDateAfterChange"
              hideIcon
            ></date-selector>
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <date-selector
              label="Hoàn thành chương trình trước"
              :date="transformDateForDatePicker(endDateBefore)"
              @change="onEndDateBeforeChange"
              hideIcon
            ></date-selector>
          </v-col>
        </v-row>
        <v-row v-show="getShow" v-else-if="forAbortion">
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <date-selector
              label="Ngày thôi học sau"
              :date="transformDateForDatePicker(startDateAfter)"
              @change="onStartDateAfterChange"
              hideIcon
            ></date-selector>
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <date-selector
              label="Ngày thôi học trước"
              :date="transformDateForDatePicker(startDateBefore)"
              @change="onStartDateBeforeChange"
              hideIcon
            ></date-selector>
          </v-col>
       
        </v-row>
        <v-row v-show="getShow">
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <v-select
              flat
              filled
              clearable
              item-text="text"
              item-value="value"
              :items="genderOptions"
              placeholder="Chọn giới tính"
              v-model="gender"
            ></v-select>
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <v-select
              flat
              filled
              dense
              clearable
              :items="yearOptions"
              placeholder="Chọn năm sinh"
              v-model="year"
            ></v-select>
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <v-text-field
              v-model="tags"
              clear-icon="mdi-close"
              placeholder="Nhóm"
              flat
              filled
              dense
              clearable
            />
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <autocomplete-generation
              v-model="generations"
              item-text="name"
              item-value="id"
              placeholder="Chọn khóa"
              return-object
              deletable-chips
              clearable
              multiple
              flat
              filled
              dense
            ></autocomplete-generation>
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <v-text-field
              v-model="email"
              clear-icon="mdi-close"
              placeholder="Email"
              flat
              filled
              dense
              clearable
            />
          </v-col>

          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <v-text-field
              v-model="phone"
              clear-icon="mdi-close"
              placeholder="Số điện thoại"
              flat
              filled
              dense
              clearable
            />
          </v-col>
          <v-col :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }" cols="12" md="3">
            <autocomplete-major
              v-model="major"
              item-text="title"
              item-value="id"
              placeholder="Chọn chuyên ngành"
              flat
              filled
              return-object
              auto-select-first
              dense
              required
              clearable
            />
          </v-col>
          <v-col
            v-if="forReservation"
            :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }"
            cols="12"
            md="3"
          >
            <v-select
              flat
              filled
              dense
              clearable
              item-text="text"
              item-value="value"
              :items="reservationStatusOptions"
              placeholder="Trạng thái bảo lưu"
              v-model="reservationStatus"
            ></v-select>
          </v-col>
          <v-col
            v-if="forAbortion"
            :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }"
            cols="12"
            md="3"
          >
          <v-select
          flat
              filled
              dense
              clearable
            :items="reasonTypeOptions"
            item-value="value"
            item-title="text"
            v-model="reasonType"
            label="Lí do thôi học"
          >
          </v-select>
          </v-col>
          <v-col
            v-if="forGraduation"
            :class="{ 'py-0': $vuetify.breakpoint.mdAndUp }"
            cols="12"
            md="3"
          >
          <v-select
          flat
              filled
              dense
              clearable
            :items="getStudentRankList"
            item-value="value"
            item-text="label"
            v-model="rank"
            label="Xếp loại"
          >
          </v-select>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        cols="12"
        class="d-flex justify-end"
        :class="{ 'mt-1': $vuetify.breakpoint.smAndDown }"
        md="3"
      >
        <v-btn
          depressed
          width="120px"
          height="38px"
          color="white"
          @click="show = !show"
          class="grey--text darken-1--text"
          v-show="$vuetify.breakpoint.mdAndUp"
        >
          <v-icon left dark>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon
          >Nâng cao
        </v-btn>
        <v-btn
          depressed
          width="80px"
          height="38px"
          color="amber darken-1"
          @click="onFilterChanged"
          class="white--text ml-4"
        >
          <v-icon left dark>mdi-filter-outline</v-icon>Lọc
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import DateSelector from '@/components/basic/DateSelector.vue'
import { transformDateForDatePicker } from '@/helpers'
import { mapActions, mapGetters, mapState } from 'vuex'
import AutocompleteMajor from '@/components/basic/input/AutocompleteMajor'
import AutocompleteGeneration from '@/components/basic/input/AutocompleteGeneration'
import { genderOptions, studentTypeOptions, getReservationStatusOptions } from '../../helpers'
import { get } from 'lodash'
import moment from 'moment'
import {
  reasonTypeOptions,
  getStudentRankList
} from '@/helpers'

export default {
  components: {
    DateSelector,
    AutocompleteMajor,
    AutocompleteGeneration
  },
  props: {
    forReservation: Boolean,
    forGraduation: Boolean,
    forAbortion: Boolean
  },
  data() {
    return {
      show: false,
      name: '',
      query: '',
      major: {},
      status: get(this.$route.query, 'status', 'active'),
      generations: [],
      code: '',
      tags: '',
      email: '',
      phone: '',
      type: get(this.$route.query, 'type', 'long_term'),
      gender: '',
      year: '',
      startDateAfter: '',
      startDateBefore: '',
      endDateAfter: '',
      endDateBefore: '',
      reservationStatus: '',
      reasonType: '',
      rank: ''
    }
  },
  watch: {
    statusQueryParam(v) {
      this.status = v
      this.onFilterChanged()
    },
    typeQueryParam(v) {
      this.type = v
      this.onFilterChanged()
    }
  },
  computed: {
    getStudentRankList,
    reasonTypeOptions,
    ...mapState('constant', ['studentStatuses']),
    reservationStatusOptions: getReservationStatusOptions,
    statusQueryParam() {
      return get(this.$route.query, 'status', 'active')
    },
    yearOptions() {
      const currentYear = new Date().getFullYear()
      return Array(100)
        .fill(0)
        .map((_, index) => currentYear - (index + 1))
    },
    typeQueryParam() {
      return get(this.$route.query, 'type', 'long_term')
    },
    genderOptions,
    studentTypeOptions,
    getShow() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return true
        default:
          return this.show
      }
    }
  },
  methods: {
    onStartDateAfterChange(v) {
      this.startDateAfter = moment(v, 'YYYY-MM-DD').toISOString()
    },
    onStartDateBeforeChange(v) {
      this.startDateBefore = moment(v, 'YYYY-MM-DD').toISOString()
    },
    onEndDateAfterChange(v) {
      this.endDateAfter = moment(v, 'YYYY-MM-DD').toISOString()
    },
    onEndDateBeforeChange(v) {
      this.endDateBefore = moment(v, 'YYYY-MM-DD').toISOString()
    },

    transformDateForDatePicker,
    onFilterChanged() {
      const payload = {
        reason_type: this.reasonType || '',
        rank: this.rank || '',
        generation: this.getGenerations() || '',
        majors: this.getMajor(),
        tags_contains: this.tags || '',
        code_contains: this.code || '',
        status: this.status || '',
        type: this.type || '',
        gender: this.gender || '',
        phone_contains: this.phone || '',
        email_contains: this.email || '',
        name_contains: this.name || '',
        year: this.year || '',
        _sort: 'createdAt:desc',
        reservation_status: this.reservationStatus || ''
      }
      if (this.startDateAfter) {
        payload.start_date_gte = moment(this.startDateAfter).startOf('day').toISOString()
      }
      if (this.startDateBefore) {
        payload.start_date_lte = moment(this.startDateBefore).endOf('day').toISOString()
      }
      if (this.endDateAfter) {
        payload.end_date_gte = moment(this.endDateAfter).startOf('day').toISOString()
      }
      if (this.endDateBefore) {
        payload.end_date_lte = moment(this.endDateBefore).endOf('day').toISOString()
      }
      this.$emit('onFilterChanged', payload)
    },
    reset() {
      this.how = false
      this.query = ''
      this.year = ''
      this.major = {}
      this.course = ''
      this.status = 'active'
      this.type = ''
      this.gender = ''
      this.generations = ''
      this.tags = ''
      this.email = ''
      this.name = ''
      this.phone = ''
      this.code = ''
      this.reasonType = ''
      this.rank = ''
    },
    getMajor() {
      return this.major ? this.major.id : ''
    },
    getGenerations() {
      return this.generations ? this.generations.map(generation => generation.id) : ''
    },
    onStartDateRangeChanged(v) {
      this.startDateRange = v
    },
    onEndDateRangeChanged(v) {
      this.endDateRange = v
    }
  }
}
</script>
